<template>
  <v-container class="elegant-container">
    <v-row>
      <v-col cols="12" class="text-center">
        <h2 class="font-weight-bold mb-2">수강 리뷰</h2>
        <p class="text-subtitle-1 text-medium-emphasis mb-8">학생들의 소중한 후기를 확인해보세요</p>
      </v-col>
      
      <v-col cols="12" md="4"
             v-for="review in reviewList" 
             v-bind:key="review.id"
             class="mb-4">
        <v-card class="review-card h-100 mx-auto" 
                elevation="2" 
                max-width="400"
                @click="selectPost(review)">
          <v-card-text class="pa-5 text-center">
            <!-- Rating Stars -->
            <div class="mb-3">
              <v-icon 
                v-for="n in 5" 
                :key="n" 
                :color="n <= (review.rating || 5) ? 'amber darken-2' : 'grey lighten-1'"
                size="20"
                class="mx-1"
              >
                mdi-star
              </v-icon>
            </div>
            
            <!-- Quote Icon -->
            <v-icon color="primary" class="quote-icon mb-3" size="24">mdi-format-quote-open</v-icon>
            
            <!-- Review Text -->
            <p class="review-text mb-4">{{ review.reviewText }}</p>
            
            <!-- Student Name and Meta info -->
            <h4 class="font-weight-medium mb-0">{{ review.studentName }}</h4>
            <div class="d-flex justify-center align-center mt-1">
              <v-icon small color="grey lighten-1" class="mr-1">mdi-calendar</v-icon>
              <span class="text-caption text-medium-emphasis mr-3">{{ formatDate(review.createdAt) }}</span>
              <v-icon small color="grey lighten-1" class="mr-1">mdi-account</v-icon>
              <span class="text-caption text-medium-emphasis">{{ review.teacherName }}</span>
            </div>
            
            <!-- View Details Button -->
            <v-btn 
              color="primary" 
              small 
              outlined
              rounded
              class="mt-4"
            >
              <v-icon left x-small>mdi-eye</v-icon>
              자세히
            </v-btn>
            
            <!-- Manager Feedback Section -->
            <div v-if="isManager || !review.createdAt" class="mt-4 text-left feedback-section">
              <div class="d-flex align-center">
                <v-icon color="primary" small class="mr-2">mdi-comment-text-outline</v-icon>
                <span class="font-weight-medium">개선할점</span>
              </div>
              <p class="review-feedback mt-2 text-body-2">{{ review.feedback }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" class="d-flex justify-center mt-4">
        <v-pagination 
          v-model="page" 
          :length="total"
          @input="searchPosts" 
          class="elegant-pagination review-pagination"
          color="primary"
        />
      </v-col>
    </v-row>

    <dialog-review
        :value="isShowBoard"
        @input="isShowBoard = $event"
        :selected-review="selectedRow"
        @hideDialog="hideDialog"
    />
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import apiReview from "@/api/modules/api-review";
import DialogReview from "@/components/Dialog/DialogReview";
import {common_date} from "@/utils/common_date";

export default {
  name: 'InfoReview',
  components: {
    DialogReview
  },
  data() {
    return {
      isShowBoard: false,
      selectedRow: {},

      reviewList: [],
      total: 0,
      page: 1,
      searchQuery: {
        content: '',
        title: '',
        page: 0,
        size: 6,
        sort: 'id,desc',
      }
    }
  },
  watch:{},
  computed: {
    ...mapGetters(['app', 'user', 'isManager']),
  },
  mounted() {
    this.searchPosts()
  },
  methods: {
    searchPosts(){
      this.searchQuery.page = this.page - 1

      return apiReview.getReviewPage(this.searchQuery)
          .then(res => {
            this.reviewList = res.content.map(review => {
              review.studentName = review.studentName.substring(0,1) + '*' + review.studentName.substring(2,3)
              return review
            })
            this.total = res.totalPages
            return res
          })
          .finally(() => this.listLoading = false)
    },
    selectPost(post){
      this.isShowBoard = true
      this.selectedRow = post
    },
    hideDialog(){
      this.isShowBoard=false
      this.selectedRow = []
    },
    formatDate(date){
      return common_date.changeFormatDate(date)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
@import "@/assets/scss/elegant-theme.scss";

.review-card {
  border-radius: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1) !important;
  }
}

.quote-icon {
  opacity: 0.6;
  display: block;
  margin: 0 auto;
}

.review-text {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #555;
  min-height: 100px;
  position: relative;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.feedback-section {
  background-color: rgba(59, 130, 246, 0.05);
  border-radius: 8px;
  padding: 12px;
  margin-top: 16px;
}

.review-feedback {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 0;
}

@media (max-width: 600px) {
  .review-text {
    min-height: 80px;
    -webkit-line-clamp: 4;
    font-size: 0.9rem;
  }
}
</style>